import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLibModule } from '@nrwl/common-lib';
import { CommonMaterialModule } from '@nrwl/common-material';
import { TestSetupModule } from '@nrwl/test-setup';
import { AddApplicationComponent } from './setup/component/add-application/add-application.component';
import { ServiceTestSetupComponent } from './setup/service-setup.component';
import { ServiceSetupService } from './setup/service-setup.service';
import { ServiceSetupAdvanceTabComponent } from './setup/tabs/service-setup-adavance-tab/service-setup-advance-tab.component';
import { ServiceSetupBasicTabComponent } from './setup/tabs/service-setup-basic-tab/service-setup-basic-tab.component';
import { DataSourceManagementModule } from '@nrwl/datasource-management';
import { ViaviTabulatorModule } from '@nrwl/viavi-tabulator';
import { MonitorManagementModule } from '@nrwl/monitor-management';

@NgModule({
    imports: [
        CommonModule,
        CommonLibModule,
        CommonMaterialModule,
        TestSetupModule,
        FormsModule,
        ReactiveFormsModule,
        DataSourceManagementModule,
        ViaviTabulatorModule,
        MonitorManagementModule
    ],
    declarations: [
        ServiceTestSetupComponent,
        ServiceSetupBasicTabComponent,
        ServiceSetupAdvanceTabComponent,
        AddApplicationComponent
    ],
    providers: [ServiceSetupService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ServiceTestModule {}
